import api from "../backAxios"

class RestricaoTipoPagamentoService {

  async getTiposPagamentos() {
    return (await api.get('/pagamentos/tipos-pagamento')).data
  }
  async getAssociadosAfetadosRestricao(queryParams) {
    return (await api.get(`/pagamentos/restricao-tipo-pagamento/associado-restrito?${queryParams}`)).data
  }
  async getRestricoesPagamento() {
    try{
      const {data} = await api.get('/pagamentos/restricao-tipo-pagamento')
      return data 
    }catch(err){
      throw err
    }
  }
  async registrarRestricoesPagamento(restricoes) {
    try{
      await api.post('/pagamentos/restricao-tipo-pagamento', restricoes)
    }catch(err){
      throw err
    }
  }
  async deletarRestricoesPagamento(arrayRegras) {
    try{
      
      const response = await api.delete('/pagamentos/restricao-tipo-pagamento',{
        data: arrayRegras
      })
      return response.status
    }catch(err){
      throw err
    }
  }

} 

export default new RestricaoTipoPagamentoService()